import service from "./request";

/**   EG
 * 封装get post 的 两种方式
 * @param params 传入的阐述
 * @param path 为路径
 * @returns {Promise}
 */
// get
// export const $getSendCode = (params = {}) => {
//   return service.post("/path", params);
// };
// 添加搜索记录
export const $postsearchLog = (params = {}) => {
  return service.post("store/search_log", params);
};

// 获取地区id
export const $getAreaValue = (params = {}) => {
  return service.get("store/get_area_value", {
    params,
  });
};
// 默认配置数据
export const $getdefaultSetting = (params = {}) => {
  return service.get("store/default_setting", {
    params,
  });
};
export const $getTicket = (params = {}) => {
  return service.get("store/ticket", {
    params,
  });
};
/**
 * 封装post 上传formaData数据
 * @param url  
 * @param formData  file参数记得使用 const formData = new FormData();
        formData.append("file", file);
 * @returns {Promise}
 */
export const $uploadFormData = ({ formData, onUploadProgress = (e) => {} }) => {
  const config = {
    headers: {
      ...service.defaults.headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  };
  return service.post(`/facilities/local`, formData, config);
};
/** */

//mei start

// post
export const $postStudentLogin = (params = {}) => {
  return service.post("student/student_login", {
    params,
  });
};

//mei end

// 获取地区
export const $getArea = (params = {}) => {
  return service.get("sidon/get_area", {
    params,
  });
};
// 获取门店列表
export const $getStoreList = (params = {}) => {
  return service.get("store/store_list", {
    params,
  });
};
// 更新门店经纬度
export const $updataStore = (params = {}) => {
  return service.post("store/update_store", params);
};

// 获取城市列表
export const $cityJson = () => {
  return service.get("/cityJson");
};